export default "__VITE_ASSET__3pN3wPRD__"